// FLAGS: none
// The save/cancel pair shown while a note section is in edit mode.
import React from "react";
import Button from "@openup/shared/components/Button/Button";
import { useTranslation } from "react-i18next";

interface SaveCancelProps {
  onSave: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

const SaveCancelButtons: React.FC<SaveCancelProps> = ({
  onSave,
  onCancel,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end">
      <div className="flex mt-2">
        <Button className="mr-4" onClick={onSave} loading={isSubmitting}>
          {t("EditableMarkdownSection.Save")}
        </Button>
        <Button variant="quaternary" onClick={onCancel}>
          {t("EditableMarkdownSection.Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default SaveCancelButtons;
